import React, { Component, Children, forwardRef } from 'react';
import { Popper } from '@material-ui/core';
import Autosuggest from 'react-autosuggest';

import { call } from 'utils';

import styles from './InputComponent.module.scss';

const theme = {
  container: {
    padding: 0,
    width: '100%',
  },
};

class InputComponent extends Component {
  constructor(props) {
    super(props);

    this.anchorRef = React.createRef();
    this.valueInputRef = React.createRef();
    this.textInputRef = React.createRef();

    this.renderInputComponent = this.renderInputComponent.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);

    this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(this);
  }

  renderInputComponent(inputProps) {
    const attachRef = el => {
      this.textInputRef.current = el;

      if (typeof inputProps.ref === 'function') {
        inputProps.ref(el);
      } else if (inputProps.ref) {
        inputProps.ref.current = el;
      }
    };

    return (
      <div ref={this.anchorRef}>
        <input {...inputProps} ref={attachRef} />

        <input {...this.props.replacedProps} ref={this.valueInputRef} type="hidden" />
      </div>
    );
  }

  renderSuggestionsContainer({ containerProps, children }) {
    if (this.anchorRef.current) {
      const width = this.anchorRef.current.offsetWidth;
      const hasOptions = !!Children.count(children);

      return (
        <Popper
          open={hasOptions}
          anchorEl={this.anchorRef.current}
          placement="bottom-start"
          style={{ zIndex: 9999 }}
        >
          <div className={styles.popup} style={{ width, maxHeight: '20vh' }}>
            <div {...containerProps}>{children}</div>
          </div>
        </Popper>
      );
    }

    return null;
  }

  changeValue(value) {
    const input = this.valueInputRef.current;

    if (input) {
      const event = new Event('input', { bubbles: true });

      input.value = value;
      input.dispatchEvent(event);

      call(this.props.replacedProps.onChange, event);
    }
  }

  onSearchChange(event) {
    if (event.target === this.textInputRef.current) {
      call(this.props.onChange, event.target.value);
      this.changeValue('');
    }
  }

  onSuggestionSelected(_event, { suggestion }) {
    call(this.props.onChange, suggestion.text);
    this.changeValue(suggestion.id);
  }

  render() {
    const { reference, autoSuggestProps, replacedProps, inputRef, ...inputProps } =
      this.props;

    return (
      <Autosuggest
        {...autoSuggestProps}
        ref={reference}
        renderInputComponent={this.renderInputComponent}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        onSuggestionSelected={this.onSuggestionSelected}
        shouldRenderSuggestions={() => true}
        inputProps={{
          ...inputProps,
          onChange: this.onSearchChange,
        }}
        theme={theme}
      />
    );
  }
}

export default forwardRef((props, ref) => <InputComponent {...props} reference={ref} />);
